<template>
  <Layout>
    <DsIslandsContainer>
      <div class="bg-back-layer1">
      <!-- language switcher -->
      <DsSegmentedControl v-model="model">
        <DsSegmentedControlItem v-for="(data, index) in languages" :title="data.label" :key="index">
      <DsIsland class="body-500 bg-back-layer1">
        <!-- title  -->
        <DsTitle size="h2">
          <span v-html="translateLoc(data.value,'goldkid-agreement:title')"/>
        </DsTitle>
        <!-- agreement  -->
        <div class="px-spacing-500 mt-spacing-600">
          <p v-html="translateLoc(data.value,'goldkid-agreement:part-1', getUserName, kidParentData.parentData.iin, kidParentData.kidData.iin)">
          </p>

          <p class="mt-spacing-600" v-html="translateLoc(data.value,'goldkid-agreement:part-2')" >
          </p>

          <p class="mt-spacing-500">
            <span v-html="translateLoc(data.value,'goldkid-agreement:part-3')"></span>
            <ul class="list-disc pl-7">
              <li v-html="translateLoc(data.value,'goldkid-agreement:part-4')">
              </li>
              <li v-html="translateLoc(data.value,'goldkid-agreement:part-5')">
              </li>
              <li v-html="translateLoc(data.value,'goldkid-agreement:part-6')">
              </li>
              <li>
                <span v-html="translateLoc(data.value,'goldkid-agreement:kid-phone', getKidData.phone)" />
              </li>
            </ul>
          </p>
          <DsTitle class="-ml-spacing-500 mt-spacing-400" size="h3">
            <div v-html="translateLoc(data.value,'goldkid-agreement:form')" />
          </DsTitle>
          <DsTable textSize="large" class="-mx-spacing-500">
            <DsTableRow>
              <DsTableCell>
                <template #caption>
                  <div v-html="translateLoc(data.value,'goldkid-agreement:born-in-usa')" />
                </template>
              </DsTableCell>
              <DsTableCell>
                <div v-html="translateLoc(data.value,'goldkid-agreement:no')"/>
              </DsTableCell>
            </DsTableRow>
            <DsTableRow>
              <DsTableCell>
                <template #caption>
                  <div v-html="translateLoc(data.value,'goldkid-agreement:taxpayer')" />
                </template>
              </DsTableCell>
              <DsTableCell>
                <div v-html="translateLoc(data.value,'goldkid-agreement:no')"/>
              </DsTableCell>
            </DsTableRow>
            <DsTableRow>
              <DsTableCell>
                <template #caption>
                  <div v-html="translateLoc(data.value,'goldkid-agreement:register-usa')" />
                </template>
              </DsTableCell>
              <DsTableCell>
                <div v-html="translateLoc(data.value,'goldkid-agreement:no')"/>
              </DsTableCell>
            </DsTableRow>
            <DsTableRow>
              <DsTableCell>
                <template #caption>
                  <div v-html="translateLoc(data.value,'goldkid-agreement:have-offshores')" />
                </template>
              </DsTableCell>
              <DsTableCell>
                <div v-html="translateLoc(data.value,'goldkid-agreement:no')"/>
              </DsTableCell>
            </DsTableRow>
            <DsTableRow>
              <DsTableCell>
                <template #caption>
                  <div v-html="translateLoc(data.value,'goldkid-agreement:foreign-family')" />
                </template>
              </DsTableCell>
              <DsTableCell>
                <div v-html="translateLoc(data.value,'goldkid-agreement:no')"/>
              </DsTableCell>
            </DsTableRow>
          </DsTable>
        </div>
      </DsIsland>
      <DsIsland class="overflow-auto p-spacing-500" style="height: auto;">
        <DsTable class="-mx-spacing-500">
          <DsTableRow>
            <DsTableCell>
              <div class="label-500-soft" v-html="translateLoc(data.value,'goldkid-agreement:date')"></div>
              <div class="label-500 mt-spacing-350">{{ currentDate }}</div>
            </DsTableCell>
          </DsTableRow>
          <DsTableRow>
            <DsTableCell>
              <div class="label-500-soft" v-html="translateLoc(data.value,'goldkid-agreement:client', getUserName)"></div>
              <div class="label-500 mt-spacing-350"  v-html="translateLoc(data.value,'goldkid-agreement:sign-info')" />
            </DsTableCell>
          </DsTableRow>
          <DsTableRow>
            <DsTableCell>
              <div class="label-500-soft" v-html="translateLoc(data.value,'goldkid-agreement:sign-manager')"></div>
              <div class="label-500 mt-spacing-350"  v-html="translateLoc(data.value,'goldkid-agreement:sign-method')" />
            </DsTableCell>
          </DsTableRow>
        </DsTable>
      </DsIsland>
        </DsSegmentedControlItem>
      </DsSegmentedControl>
        <!-- button -->
      <DsDivider />

      <DsButtonBar sticky>
        <DsButton @click="nextPage" size="large">
          <div class="label-600-soft">
            {{ translateLoc(language,'goldkid-agreement:sign-btn') }}
          </div>
        </DsButton>
      </DsButtonBar>
      <!-- Alerts -->
      <Otp v-if="isOtpActive" v-model="isOtpActive" />
      <DsAlert :visible="alertRef.server.value" layout="vertical">
        <template #title>
          {{ alertRef.server.title }}
        </template>
        <template #description>
          {{ alertRef.server.text }}
        </template>
        <DsButton type="ghost" size="large" @click="alertRef.server.value = false">
          OK
        </DsButton>
      </DsAlert>
      </div>
    </DsIslandsContainer>
  </Layout>
</template>

<script setup>
import { DsIslandsContainer, DsIsland, DsTitle, DsTable, DsTableRow, DsTableCell, DsButtonBar, DsButton, DsDivider, DsAlert, DsSegmentedControl, DsSegmentedControlItem } from '@ds/vue2'
import { getLocale } from '@/modules/locale/locale'
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import Otp from '@/components/Otp/Otp'
import { getDeviceType } from '@/helpers/getDeviceType'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import translate from '@/filters/translate.filter'
import useStore from '@/composables/useStore'
import useHeader from '@/composables/useHeader'
import Layout from '@/components/ui/Layout/Layout.vue'
const store = useStore()
const {setBackFn, setTitle} = useHeader()
const model = ref(0)
setBackFn(() => {
  store.dispatch('goldkidProcess/component', 'enterPhone')
})
setTitle(translate('title:goldkid'))

defineProps({
  value: {
    required: true,
    type: Boolean
  }
})
const emit = defineEmits(['input' , 'activateOtp'])
const isIos = computed(() => {
  return getDeviceType() === 'ios'
})
const kidParentData =ref({
  parentData: {
    firstName: '',
    lastName: '',
    middleName: '',
    iin: ''
  },
  kidData: {
    firstName: '',
    lastName: '',
    middleName: '',
    iin: ''
  }
})
const language= ref('ru-RU')
const isOtpActive = ref(false)
const alertRef = ref({
  server: {
    value: false,
    title: '',
    text: ''
  }
})
const languages = [
  {
    label: 'Рус',
    value: 'ru-RU'
  },
  {
    label: 'Қаз',
    value: 'kk-KZ'
  }
]
const currentDate = computed(() => {
  const currentDate = store.getters['goldkidProcess/currentDate']
  return language.value === 'kk-KZ' ? currentDate.currentDateKz + ' ж.' : currentDate.currentDateRu + ' г.'
})

const getUserName = computed(() => {
  if (!kidParentData.value.parentData.firstName) return '___'
  return `${kidParentData.value.parentData?.lastName} ${kidParentData.value.parentData?.firstName} ${kidParentData.value.parentData?.middleName ? kidParentData.value.parentData?.middleName : ''}`
})
const getKidData = computed(() => {
  return store.getters['goldkidProcess/kidData']
})

onMounted(async () => {
  await dataStep()
  const lang = language.value === 'ru-RU' ? 'russian' : 'kazakh'
  sendAnalyticEvent('online_child_gold_application', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    language: [lang],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
})

const dataStep= async () => {
  const response = await store.dispatch('goldkidProcess/dataStep')
  kidParentData.value = { ...response?.data?.data }
}

const nextPage = async () => {
  const data = {
    kidIin: kidParentData.value.kidData.iin,
    kidPhoneNumber: getKidData.value.phone
  }
  eventBus.$emit('kaspiLoading', true)
  const response = await store.dispatch('goldkidProcess/processStep', {
      data,
      meta: store.getters['goldkidProcess/meta']
    })
    .catch(e => {
      store.dispatch('goldkidProcess/component', 'error')
    })
  // api call suceed, turning off loader
  eventBus.$emit('kaspiLoading', false)
  const component = response?.data?.data?.component

  if (component === 'otp') {
    isOtpActive.value = true
  }

  // Обработка ошибки валидации с сервера
  if (response?.data?.result.toLowerCase?.() === 'error') {
    alertRef.value.server = {
      value: true,
      title: response.data.data.title,
      text: response.data.data.message
    }
  }

  if (component && component !== 'otp') {
    store.dispatch('goldkidProcess/component', component)
  }
}

onBeforeUnmount(() => {
  const lang = language.value === 'ru-RU' ? 'russian' : 'kazakh'
  sendAnalyticEvent('online_child_gold_application', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['finish'],
    language: [lang],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
})

watch(language, (lang) => {
  if (!lang) {
    language.value = getLocale()
    return
  }

  const language = lang === 'ru-RU' ? 'russian' : 'kazakh'

  sendAnalyticEvent('online_child_gold_application', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    language: [language],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
}, {
  immediate: true
})
</script>
